import "bootstrap-icons/font/bootstrap-icons.css";

function SelectedOpportunityCard({ opportunity, onClear, readOnly = false }) {
    const { title, opportunity: opportunityText } = opportunity ?? {};

    return (
        <div className="relative min-w-0 max-w-full overflow-hidden rounded-2xl bg-gradient-to-br from-indigo-50 via-violet-50 to-fuchsia-50 px-4 py-4 md:px-5 md:py-5">
            <div className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-violet-200/40 blur-2xl" />

            {!readOnly && onClear ? (
                <button
                    type="button"
                    onClick={onClear}
                    className="absolute right-3 top-3 inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/80 text-slate-500 shadow-sm transition hover:bg-white hover:text-slate-900"
                    aria-label="Remove opportunity"
                >
                    <i className="bi bi-x-lg text-sm" aria-hidden />
                </button>
            ) : null}

            {title ? (
                <h3 className="relative mb-2 break-words pe-8 text-base font-semibold leading-snug text-slate-900 md:text-lg">
                    {title}
                </h3>
            ) : null}

            {opportunityText ? (
                <p className="relative mb-0 break-words text-sm font-medium leading-relaxed text-slate-900 md:text-base">
                    {opportunityText}
                </p>
            ) : null}
        </div>
    );
}

export default function SelectedOpportunityPreview({
    opportunities = [],
    onRemove,
    readOnly = false,
}) {
    if (!opportunities.length) return null;

    return (
        <div className="min-w-0 w-full space-y-3">
            {opportunities.map((item, index) => {
                const id = item.id ?? index;

                return (
                    <SelectedOpportunityCard
                        key={id}
                        opportunity={item}
                        onClear={
                            readOnly || !onRemove ? undefined : () => onRemove(item.id)
                        }
                        readOnly={readOnly}
                    />
                );
            })}
        </div>
    );
}
